import { uuidv4 } from './identity';

/**
 * The id of this page load, shared by everything that reports about it.
 *
 * It used to live inside the device collector, which was fine while that collector was the only
 * thing reporting a visit. The behaviour snapshot is keyed on the same id, and two generators would
 * produce two ids for one visit — rows that can never be joined back together.
 *
 * A visit is one document load: a reload is a new visit, and nothing here is persisted.
 */
let visitId: string | null = null;

export const getVisitId = (): string => {
  if (visitId === null) visitId = uuidv4();
  return visitId;
};

export const _resetVisitIdForTests = (): void => {
  visitId = null;
};
